
<div class="form-group">
  <div class="container mt-5">
    <div class="row section">
      <form [formGroup]="iaevent">
        <h2><u>Event Preview Details</u></h2>
        <div class="row">
          <div class="col-md-6">
            <p><strong>Event Organization By:</strong> {{ data['eventOrganisedName'] }}</p>
          </div>
          <div class="col-md-6">
            <p><strong>Implementation Agency:</strong> {{ data['implementationAgencyName'] }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <p><strong>Event Name:</strong> {{ data['eventName'] }}</p>
          </div>
          <div class="col-md-3">
            <p><strong>Event Date & Time:</strong> {{ data['eventDate'] }} &nbsp; {{ data['time'] }} </p>
          </div>
          <div class="col-md-3">
            <p><strong>Duration of Event:</strong> {{ data['eventDuration'] }}</p>
          </div>
          <div class="col-md-3">
            <p><strong>Period:</strong> {{ data['period'] }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <p><strong>Distric:</strong> {{ data['districtName'] }}</p>
          </div>
          <div class="col-md-3">
            <p><strong>City:</strong> {{ data['cityName'] }}</p>
          </div>
          <div class="col-md-3">
            <p><strong>Town/Block:</strong> {{ data['townName'] }}</p>
          </div>
          <div class="col-md-3">
            <p><strong>Village:</strong> {{ data['village'] }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <p><strong>Event Venue Details:</strong> {{ data['venueDetails'] }}</p>
          </div>
          <div class="col-md-4">
            <p><strong>Sitting Capacity:</strong> {{ data['numberofParticipants'] }}</p>
          </div>
          <div class="col-md-4">
            <p><strong>Event Focus Sector:</strong> {{ data['focusSectorName'] }}</p>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4">
            <p><strong>Intervention:</strong> {{ data['interventionName'] }}</p>
          </div>
          <div class="col-md-4">
            <p><strong>Type of Component:</strong> {{ data['interestName'] }}</p>
          </div>
        </div>

        <h1><u>Trainer Details</u></h1>
        <div class="row">
          <div class="col-md-12">
            <table class="table">
              <thead>
                <tr>
                  <th>Anchor/Trainer Name</th>
                  <th>Anchor/Trainer Company Name</th>
                  <th>Contact Number</th>
                  <th>District</th>
                  <th>City</th>
                  <th>Town/Block</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let detail of trainerData; index as i">
                  <td>{{ detail.trainerName }}</td>
                  <td>{{ detail.trainerCompanyName }}</td>
                  <td>{{ detail.contactNumber }}</td>
                  <td>{{ detail.districtName }}</td>
                  <td>{{ detail.cityName }}</td>
                  <td>{{ detail.blockName }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!--<h1><u>SPOC details</u></h1>
  <div class="row">
    <div class="col-md-9">
      <table class="table">
        <thead>
          <tr>
            <th>PersonName</th>
            <th>MobileNumber</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let detail of spocData; index as i">
            <td>{{ detail.PersonName }}</td>
            <td>{{ detail.MobileNumber }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>-->

        <div class="row">
          <div class="col-md-3">
            <label for="statusSelect">Select Status</label>
            <select class="form-control" id="Status" formControlName="status" [disabled]="action">
              <option>Select an option</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
              <option value="Rejected for Query">Rejected for Query</option>
            </select>
          </div>
        </div><br />

        <div class="row">
          <div class="col-md-6">
            <textarea id="textarea" formControlName="remarks" rows="4" cols="80" maxlength="200"></textarea>
            <div *ngIf="iaevent.get('textarea')?.invalid" class="error">
              <div *ngIf="iaevent.get('textarea')?.errors?.['required']" class="error">Remark is required.</div>
            </div>
          </div>
        </div>




        <div class="row">
          <div class="col-md-4">
            <button *ngIf="action" class="btn btn-success" (click)="onSubmit()">Submit</button>&nbsp;
            <button class="btn btn-secondary" (click)="back()">Back</button>
          </div>

        </div>

      </form>
    </div>


  </div>
  
</div>

